import { TREE_I18N_KEY, TREE_I18N_MAP } from "./tree";

export const ERROR_MESSAGES: Record<string, string> = {
	"auth-unspecified-auth-exception":
		"Login fehlgeschlagen. Bitte überprüfe Benutzername und Passwort.",
	certificates_certificate_template_not_found: "Kein Zertifikat gefunden.",
	file_already_exists: "Die Datei existiert bereits!",
	elearningv2_several_videos_in_s_3_folder:
		"Der Ordner enthält mehrere Videos. Benenne das zu veröffentlichende Video video.mp4.",
	elearningv2_no_video_in_s_3_folder:
		"Kein Video direkt im Ordner. Videos in Unterordnern werden nicht verwendet.",
	elearningv2_s_3_video_source_not_configured:
		"Die S3-Videoquelle ist auf diesem System nicht eingerichtet.",
	elearningv2_s_3_video_object_not_found:
		"Das Video ist während der Prüfung aus dem Ordner verschwunden. Bitte versuche es erneut.",
	publishingv2_tree_for_publishing_does_not_contain_content_nodes_with_elements: `Keine Elemente im ${TREE_I18N_MAP(
		TREE_I18N_KEY.tree,
	)}.`,
	publishingv2_contents_failed_to_publish:
		"Veröffentlichung fehlgeschlagen: mindestens ein Inhalt konnte nicht veröffentlicht werden. Es wurde nichts freigegeben.",
	publishingv2_publishing_already_running: `${TREE_I18N_MAP(
		TREE_I18N_KEY.tree,
	)} wird bereits veröffentlicht.`,
	tree_cant_remove_first_published_date_for_published_root_node: `Veröffentlichungszeitpunkt kann nicht gelöscht werden, da ${TREE_I18N_MAP(
		TREE_I18N_KEY.tree,
	)} bereits veröffentlicht ist.`,
	tree_published_tree_parts_can_not_be_modified: `Bereits veröffentlichte Teile des ${TREE_I18N_MAP(
		TREE_I18N_KEY.treeAttributiveGenitive,
	)} können nicht verändert werden.`,
	tree_tree_state_not_found: `Diese Aktion ist nicht möglich, da der Benutzer das ${TREE_I18N_MAP(
		TREE_I18N_KEY.tree,
	)} noch nicht gestartet hat.`,
	auth_login_with_email_and_password_unspecified_auth: "Login fehlgeschlagen!",
	auth_not_enough_permissions_exception: "Keine Berichtigung!",

	auth_user_needs_to_be_in_at_least_one_account:
		"Der Benutzer muss mindestens einem Konto zugehören.",
	auth_root_account_can_not_be_deleted: "Root Konto kann nicht gelöscht werden.",
	auth_cant_delete_only_owner_exception: "Es muss mindestens ein Admin im Konto existieren.",
	auth_user_not_activated: "Der Benutzer ist noch nicht Aktiviert.",
	auth_user_already_activated: "Der Benutzer ist hat seine E-Mail bereits aktiviert.",
	coaching_already_a_participant: "Benutzer ist bereits ein Teilnehmer",
	instructor_instructor_not_found: "Expert:in wurde nicht gefunden.",
	instructor_instructor_referenced_by_shared_offer:
		"Expert:in kann nicht gelöscht werden, da sie in einer an die Gruppe veröffentlichten Version eines Angebots enthalten ist. Abonnierende Akademien können diese Version weiter nutzen, daher reicht es nicht, sie aus dem Angebot zu entfernen und neu zu veröffentlichen.",
	billing_guest_checkout_disabled: "Der Gast-Checkout ist auf diesem System deaktiviert.",
	billing_order_not_found: "Die Bestellung wurde nicht gefunden. Bitte die Seite neu laden.",
	billing_order_has_no_customer_details: "Für diese Bestellung liegen keine Kundendaten vor.",
	billing_claim_email_cannot_be_sent:
		"Die Übernahme-E-Mail kann nur für eine bezahlte Gastbestellung gesendet werden, die noch keinem Konto zugeordnet ist.",
	billing_invoice_cannot_be_resent:
		"Für diese Bestellung liegt noch keine ausgestellte Rechnung vor, die erneut gesendet werden könnte.",
	billing_invoice_email_cannot_be_corrected:
		"Die Rechnungs-E-Mail kann nur bei einer bezahlten Bestellung geändert werden.",
	billing_invoice_email_invalid:
		"Die eingegebene Rechnungs-E-Mail ist keine gültige E-Mail-Adresse.",
	billing_order_cannot_be_closed:
		"Nur eine bezahlte Gastbestellung ohne zugeordnetes Konto kann geschlossen werden.",
	billing_order_close_reason_required: "Zum Schließen der Bestellung wird ein Grund benötigt.",
};
